/* Kuba PDP · capítulo — modal de vídeo (YouTube) + faixa parallax.
   Idempotente: o editor de temas re-renderiza seções (shopify:section:load). */
(function () {
  if (window.__kbCapituloLoaded) { if (window.__kbCapituloInit) window.__kbCapituloInit(); return; }
  window.__kbCapituloLoaded = true;

  /* --- modal de vídeo (.kb-video, CSS em kuba-ext.css) --- */
  function closeVideo() {
    var m = document.querySelector('.kb-video');
    if (m) m.remove();
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
  }
  function onKey(e) { if (e.key === 'Escape') closeVideo(); }
  function openVideo(id, title) {
    closeVideo();
    id = (id || '').trim();
    // aceita URL completa colada no campo
    var m1 = id.match(/(?:v=|youtu\.be\/|embed\/|shorts\/)([A-Za-z0-9_-]{6,})/);
    if (m1) id = m1[1];
    var m = document.createElement('div');
    m.className = 'kb-video';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    var inner = id
      ? '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1" title="' + (title || 'Vídeo').replace(/"/g, '&quot;') + '" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>'
      : '<div class="kb-video__empty">Adicione o ID do vídeo do YouTube na seção (Capítulo → Vídeo) para reproduzir aqui.</div>';
    m.innerHTML = '<div class="kb-video__box"><button type="button" class="kb-video__close" aria-label="Fechar">×</button>' + inner + '</div>';
    m.addEventListener('click', function (e) { if (e.target === m || e.target.classList.contains('kb-video__close')) closeVideo(); });
    document.body.appendChild(m);
    document.addEventListener('keydown', onKey);
    document.documentElement.style.overflow = 'hidden';
    var c = m.querySelector('.kb-video__close');
    if (c) c.focus();
  }
  window.__kbOpenVideo = openVideo;

  function video() {
    document.querySelectorAll('[data-kb-video]').forEach(function (b) {
      if (b.__kb) return;
      b.__kb = true;
      b.addEventListener('click', function () { openVideo(b.getAttribute('data-kb-video'), b.getAttribute('data-kb-video-title')); });
    });
  }

  /* --- parallax leve (mesma fórmula do design: -9% do progresso na viewport) --- */
  var raf = null, bound = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function tick() {
    raf = null;
    var vh = window.innerHeight || 1;
    document.querySelectorAll('[data-kb-parallax]').forEach(function (el) {
      var host = el.parentElement.getBoundingClientRect();
      if (host.bottom < 0 || host.top > vh) return;
      var prog = (host.top + host.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (prog * -9).toFixed(2) + '%,0)';
    });
  }
  function onScroll() { if (raf) return; raf = requestAnimationFrame(tick); }
  function parallax() {
    if (reduce) return;
    if (!document.querySelector('[data-kb-parallax]')) return;
    if (!bound) {
      bound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    onScroll();
  }

  function init() { video(); parallax(); }
  window.__kbCapituloInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
